export function arrayToTree(data, parentId) {
  let temp,tree = [];
  data.forEach(item => {
    if (item.parentId == parentId) {
      temp = arrayToTree(data, item.id);
      if (temp.length > 0) {
        item.children = temp
      }
      tree.push(item);
    }
  })
  return tree;
}

export function arrayToTreeDisabled(data, parentId) {
  let temp,tree = [];
  data.forEach(item => {
    if (item.parentId == parentId) {
      temp = arrayToTreeDisabled(data, item.id);
      if (temp.length > 0) {
        item.children = temp
      }else{
        item.disabled = true
      }
      tree.push(item);
    }
  })
  return tree;
}


export function rebuildData(value, arr) {
  let newarr = [];
  arr.forEach(element => {
    if (element.name.indexOf(value) > -1) {
      newarr.push(element);
    } else {
      if (element.children && element.children.length > 0) {
        const ab = rebuildData(value, element.children);
        const obj = {
          ...element,
          children: ab
        };
        if (ab && ab.length > 0) {
          newarr.push(obj);
        }
      }
    }
  });
  return newarr;
};



// WEBPACK FOOTER //
// ./src/views/category/utils/index.js